import { language } from "shared/language";

export const HOT_DEAL_NOT_FOUND = language.hot_deal_not_found;
export const HOT_DEAL_CATEGORY_NOT_FOUND = language.hot_deal_category_not_found;

export const HOT_DEAL_CATEGORY_EXISTED = language.hot_Deal_category_existed;
export const HOT_DEAL_EXISTED = language.hot_deal_existed;
